module.exports = __webpack_public_path__ + "annualreview2018/static/img/uk-power-network-services.b085290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/uk-power-network-services.png
// module id = vCqu
// module chunks = 10